import React, { Component } from "react";
import "../style/subscribe.scss";
import HeaderBar from "./common/HeaderBar";
import FooterBar from "./common/FooterBar";

class Subscription extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedPlan: "basic",
    };
  }

  plans = [
    {
      id: "basic",
      title: "Surprise Mini Box",
      price: "9.9",          
      total: "9.9",
      image: "",
      quantity: 1,
      description:
        "Receive a small mystery gift every day, perfect for adding a little surprise to your daily routine!",
    },
    {
      id: "standard",
      title: "Deluxe Surprise Box",
      price: "12.9",
      total: "12.9",
      image: "",
      quantity: 1,
      description:
        "Get two medium-sized mystery gifts each day, featuring unique and delightful surprises!",
    },
    {
      id: "premium",
      title: "Ultimate Mystery Box",
      price: "15.9",
      total: "15.9",
      image: "",
      quantity: 1,
      description:
        "Receive three premium surprise gifts daily, including exclusive and limited-edition items!",
    },
  ];

  handlePlanSelection = (plan) => {
    this.setState({ selectedPlan: plan }, () => {
      localStorage.setItem("cart", JSON.stringify([plan]));
      let { history } = this.props;
      history.push("/Checkout");
    });
  };

  render() {
    return (
      <React.Fragment>
        <HeaderBar {...this.props} />
        <div className="subscription-container">
          <h2 className="title">Choose Your Mystery Gift Subscription Plan</h2>
          <p className="subtitle">
            Receive exciting mystery gifts delivered to your doorstep every day.
            Pick the plan that adds joy to your life!
          </p>
          <div className="plans">
            {this.plans.map((plan) => (
              <div key={plan.id} className="plan">
                <h3>{plan.title}</h3>
                <p className="price">${plan.price}/day</p>
                <p>{plan.description}</p>
                <ul className="features">
                  <li>✔ Beautifully wrapped mystery items</li>
                  <li>✔ Exclusive and limited-edition gifts</li>
                  <li>✔ Daily surprises to brighten your day</li>
                </ul>

                <button
                  className="subscribe-btn"
                  onClick={() => this.handlePlanSelection(plan)}
                >
                  Subscribe Now
                </button>
              </div>
            ))}
          </div>
          <p className="note">Cancel anytime. No hidden fees.</p>
        </div>
        <FooterBar {...this.props} />
      </React.Fragment>
    );
  }
}

export default Subscription;
